/* tps-starter-kit.js · finish switch for sections/tps-starter-kit.liquid (Hephaestus, 6 Oct 2026; STEP 3 7 Oct).
   The finish chips are the PDP's radio chips (.chip role=radio, roving tabindex, arrow keys). Picking a finish (chip or
   its photo) sets aria-checked, the Add button's variant id + live-region name, the price (PDP split: $ / dollars /
   cents), the button price, the saving line ('' = hidden), the "Finish" readout, the photo emphasis and the heading
   link's ?variant=. Text swaps only, in reserved boxes. A sold-out finish (aria-disabled) is never picked.
   The add itself is assets/tps-addwith.js. */
(function (d) {
  function pick(s, f) {
    if (!f || f.getAttribute('aria-disabled') === 'true' || f.getAttribute('aria-checked') === 'true') return false;
    var k = s.querySelector('[data-addw]');
    if (k && k.getAttribute('aria-busy') === 'true') return false;
    s.querySelectorAll('.chip[data-sk-v]').forEach(function (b) { var on = b === f; b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; });
    s.querySelectorAll('[data-sk-pick]').forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-sk-pick') === f.getAttribute('data-sk-n')); });
    if (k) { k.setAttribute('data-addw', f.getAttribute('data-sk-v')); k.setAttribute('data-addw-name', f.getAttribute('data-sk-name')); }
    var m = f.getAttribute('data-sk-price') || '', q = function (x) { return s.querySelector(x); };
    if (q('[data-sk-d]')) { q('.pdpv9-pr .cur').textContent = m.slice(0, 1); q('[data-sk-d]').textContent = m.slice(1, -3); q('[data-sk-c]').textContent = m.slice(-2); }
    if (q('[data-sk-atcp]')) q('[data-sk-atcp]').textContent = m;
    if (q('[data-sk-sel]')) q('[data-sk-sel]').textContent = f.getAttribute('data-sk-lab');
    if (q('p[data-sk-save]')) q('p[data-sk-save]').textContent = f.getAttribute('data-sk-save') || '';
    var a = q('[data-sk-link]');
    if (a) a.setAttribute('href', a.getAttribute('href').replace(/([?&]variant=)\d+/, '$1' + f.getAttribute('data-sk-v')));
    return true;
  }
  d.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-sk] .chip[data-sk-v], [data-sk] [data-sk-pick]');
    if (!t) return;
    var s = t.closest('[data-sk]');
    pick(s, t.hasAttribute('data-sk-pick') ? s.querySelector('.chip[data-sk-n="' + t.getAttribute('data-sk-pick') + '"]') : t);
  });
  d.addEventListener('keydown', function (e) {
    var f = e.target.closest && e.target.closest('[data-sk] .chip[data-sk-v]');
    if (!f || !/^(ArrowLeft|ArrowRight|ArrowUp|ArrowDown)$/.test(e.key)) return;
    var s = f.closest('[data-sk]'), all = [].slice.call(s.querySelectorAll('.chip[data-sk-v]')).filter(function (b) { return b.getAttribute('aria-disabled') !== 'true'; });
    var i = all.indexOf(f), n = all[(i + (/Right|Down/.test(e.key) ? 1 : all.length - 1)) % all.length];
    if (n && n !== f) { e.preventDefault(); pick(s, n); n.focus(); }
  });
})(document);
